exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".NB06FRymOxJjiO0lf1E8f {\n    background-color: #EEEEEF;\n    clip-path: polygon(100% 0%, -160% 100%, 100% 100%);\n    padding-bottom: 10%;\n    margin-top: -5px;\n}\n", ""]);

// exports
exports.locals = {
	"root": "NB06FRymOxJjiO0lf1E8f"
};